import { render, staticRenderFns } from "./Idigitization.vue?vue&type=template&id=57aa6812&"
import script from "./Idigitization.vue?vue&type=script&lang=js&"
export * from "./Idigitization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports